<template>
  <div id="landing_news">
    <PostPreviewExtended
      v-for="post of extended_posts"
      :key="post.path"
      :_post="post" />

    <div id="compact_posts">
      <PostPreviewCompact
        v-for="post of compact_posts"
        :key="post.path"
        :_post="post" />
    </div>
  </div>
</template>

<script>
import PostPreviewExtended from "@/components/V2/PostPreviewExtended"
import PostPreviewCompact from "@/components/V2/PostPreviewCompact"
import HasPosts from "@/mixins/HasPosts"

export default {
  name: 'LandingNews',

  mixins: [
    HasPosts
  ],

  components: {
    PostPreviewExtended,
    PostPreviewCompact
  },

  data() {
    return {
      extended_count : 2
    }
  },

  computed : {
    compact_count : function(){
      return this.mq_lt_lg ? 2 : 3;
    },

    extended_posts : function(){
      return this.sorted_visible_posts.slice(
        0, this.extended_count
      );
    },

    compact_posts : function(){
      return this.sorted_visible_posts.slice(
        this.extended_count,
        this.extended_count + this.compact_count
      );
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/scss/custom.scss';

#compact_posts{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
</style>
